import React from 'react'

import { Button, Text } from '@/components/common'
import { useSignUp } from '@/components/Providers/SignUpProvider'
import Yup from '@/utils/yup'
import Form from '@/components/forms/Form'
import InputField from '@/components/forms/InputField'
import PasswordInputField from '@/components/forms/PasswordInputField'

import FormBox from './FormBox'
import SignUpLayout from './SignUpLayout'
import styles from './SignUp.module.scss'

const ResetPassword = () => {
  const { saveStepResetPassword, user, handleForgotPassword, isRequestingPasswordReset } = useSignUp()
  const schema = Yup.object({
    email: Yup.string().trim(),
    password: Yup.string().trim().required(),
  })

  const saveData = (model) => {
    saveStepResetPassword(model)
  }

  return (
    <SignUpLayout split={false}>
      <FormBox shouldCalculateMargin={false}>
        <Text.P center noMargin size="small">
          <strong>We sent a new password to your email on file.</strong>
          <br />
          Enter the new password below to continue.
        </Text.P>

        <div className="text-center">
          <Form initialValues={{ email: user.email, password: '' }} onSubmit={saveData} schema={schema}>
            <InputField
              containerProps={{ noMargin: true }}
              disabled
              hidden
              labelProps={{ hidden: true }}
              name="email"
              value={user.email}
            />
            <PasswordInputField />

            <p className={styles.text}>
              If you did not receive the email, <Button disabled={isRequestingPasswordReset} onClick={handleForgotPassword} size="xsmall" variant="link">click here to try again</Button>.
            </p>
            <p className={styles.text}>
              Still need help signing into your account? <a href="https://support.neat.com/neatapp/create-case-web-2-0" rel="noreferrer" target="_blank">Contact us</a>.
            </p>

            <Form.Action
              className={styles.submit}
              disabled={isRequestingPasswordReset}
              messageId="cta.continue"
              size="large"
              type="submit"
            />
          </Form>
        </div>
      </FormBox>
    </SignUpLayout>
  )
}

export default ResetPassword
